// Current Care — GREEN theme for the logged-in customer/dashboard area.
// Scoped to CustomerLayout via a nested ConfigProvider in App.js so the
// dashboard reads green while the public marketing site stays blue (theme.js).
const BRAND = '#2d5a3d'; // deep care green (primary)
const BRAND_LIGHT = '#52b788'; // bright green

const fontStack =
  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

const customerTheme = {
  token: {
    colorPrimary: BRAND,
    colorLink: '#3d7a4d',
    colorLinkHover: BRAND_LIGHT,
    colorSuccess: BRAND_LIGHT,
    colorWarning: '#f1a134', // logo gold
    colorError: '#e5484d',
    colorInfo: '#2e9bd6', // logo blue
    colorTextSecondary: '#6b7280',
    borderRadius: 10,
    fontFamily: fontStack,
    fontSize: 14,
    controlHeight: 40,
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 42,
      fontWeight: 600,
      primaryShadow: '0 6px 16px -6px rgba(45, 90, 61, 0.5)',
    },
    Input: {
      borderRadius: 10,
      controlHeight: 42,
    },
    Select: {
      borderRadius: 10,
      controlHeight: 42,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Menu: {
      itemColor: '#475569',
      itemSelectedColor: BRAND,
      itemHoverColor: BRAND,
      horizontalItemSelectedColor: BRAND,
      fontWeight: 500,
    },
    Typography: {
      fontFamily: fontStack,
    },
  },
};

export default customerTheme;
